const reviews = [
    {
        id: 1,
        name: 'susan smith',
        job: 'web developer',
        image: 'https://randomwordgenerator.com/img/picture-generator/57e5d5434d55ad14f1dc8460962e33791c3ad6e04e507440722d72d1914ccc_640.jpg',
        text:  " I'm baby meggings twee health goth +1. Bicycle rights tumeric chartreuse before they sold out chambray pop-up. Shaman humblebrag pickled coloring book salvia hoodie, cold-pressed four dollar toast everyday carry",
    },
    {
        id: 2,
        name: 'anna johnson',
        job: 'web designer',
        image: 'https://randomwordgenerator.com/img/picture-generator/53e0d3424353ac14f1dc8460962e33791c3ad6e04e50744172277fd7924fcd_640.jpg',
        text: 'Helvetica artisan kinfolk thundercats lumbersexual blue bottle. Disrupt glossier gastropub deep v vice franzen hell of brooklyn twee enamel pin fashion axe.photo booth jean shorts artisan narwhal.',
    },
    {
        id: 3,
        name: 'peter jones',
        job: 'intern',
        image: 'https://randomwordgenerator.com/img/picture-generator/55e8d3454d51b10ff3d8992cc12c30771037dbf85254794e722a73d4944b_640.jpg',
        text: 'Sriracha literally flexitarian irony, vape marfa unicorn. Glossier tattooed 8-bit, fixie waistcoat offal activated charcoal slow-carb marfa hell of pabst raclette post-ironic jianbing swag.',
    },
    {
        id: 4,
        name: 'bill anderson',
        job: 'the boss',
        image: 'https://randomwordgenerator.com/img/picture-generator/5fe4d14a4a5ab10ff3d8992cc12c30771037dbf85254784b772872d39e44_640.jpg',
        text: 'Edison bulb put a bird on it humblebrag, marfa pok pok heirloom fashion axe cray stumptown venmo actually seitan. VHS farm-to-table schlitz, edison bulb pop-up 3 wolf moon tote bag street art shabby chic. ',
    },
    {
        id: 5,
        name: 'hadiyya tasha',
        job: 'auctioneer',
        image: 'https://randomwordgenerator.com/img/picture-generator/55e0dc444c50aa14f1dc8460962e33791c3ad6e04e507441722a72dd9345c7_640.jpg',
        text: 'View fine me gone this name an rank. Compact greater and demands mrs the parlors. Park be fine easy am size away. Him and fine bred knew. At of hardly sister favour. As society explain country raising weather of.',
    },
    {
        id: 6,
        name: 'karina kaniehtiio',
        job: 'medical student',
        image: 'https://randomwordgenerator.com/img/picture-generator/57e8d0424a55ad14f1dc8460962e33791c3ad6e04e50744172297cd5974ac0_640.jpg',
        text: 'Sentiments nor everything off out uncommonly partiality bed. Bringing unlocked me an striking ye perceive.',
    },
    {
        id: 7,
        name: 'nikitha artaxerxes',
        job: 'judge',
        image: 'https://randomwordgenerator.com/img/picture-generator/57e8d1474b53ac14f1dc8460962e33791c3ad6e04e50744077277dd1954ac5_640.jpg',
        text: 'Mr by wound hours oh happy. Me in resolution pianoforte continuing we. Most my no spot felt by no.',
    },
    {
        id: 8,
        name: 'ji-Won carolina',
        job: 'homemaker',
        image: 'https://randomwordgenerator.com/img/picture-generator/55e5d5454b5aac14f1dc8460962e33791c3ad6e04e507440772d7cdd914ec6_640.jpg',
        text: 'He he in forfeited furniture sweetness he arranging. Me tedious so to behaved written account ferrars moments. Too objection for elsewhere her preferred allowance her.',
    },
];

export default reviews;